<template>
  <v-card style="height: calc(100vh - 48px)">
    <v-card-text>
      <v-row class="mx-0">
        <v-col cols="2">
          <select-project
            v-model="project"
            :loading="isLoading"
          />
          <v-select
            v-model="searchBy"
            class="mt-2"
            label="Search by"
            :items="['login', 'account_id']"
            hide-details
          />
          <v-autocomplete
            v-model="selectedPaymethods"
            class="mt-2 paymethods-autocomplete"
            label="Select paymethods"
            :items="paymethods"
            :placeholder="project ? 'Select paymethods' : 'Select a project first'"
            :disabled="!project"
            :loading="isLoading"

            clearable
            multiple
          >
            <template #append-outer>
              <v-btn
                v-if="selectedPaymethods.length !== paymethods.length"
                color="primary"
                text
                @click="selectedPaymethods = [...paymethods]"
              >
                All
              </v-btn>
            </template>
          </v-autocomplete>
          <v-row class="mx-0 justify-end">
            <v-tooltip
              v-if="accounts.length"
              bottom
            >
              <template #activator="{on, attrs}">
                <v-btn
                  color="primary"
                  v-on="on"
                  v-bind="attrs"
                  @click="onWhitelistAll"
                >
                  All for All
                </v-btn>
              </template>
              <span>Find selected accounts in all projects and whitelist all available paymethods for that project for those accounts</span>
            </v-tooltip>
            <v-btn
              v-if="accounts.length"
              icon
              color="error"
              :loading="isLoading"
              @click="accounts = []"
            >
              <v-icon>
                close
              </v-icon>
            </v-btn>

            <v-btn
              icon
              color="primary"
              :disabled="!accounts.length"
              :loading="isLoading"
              @click="onUpdateConfirm"
            >
              <v-icon>
                check
              </v-icon>
            </v-btn>
          </v-row>
        </v-col>
        <v-col cols="10">
          <template v-if="!accounts.length">
            <v-textarea
              v-model="rawAccounts"
              label="Accounts"
              auto-grow
              class="accounts-list-textarea"
              :hint="`One ${searchBy} per line, click confirm when data is correct`"
            />
            <v-btn
              class="mt-2 ml-auto"
              color="primary"
              @click="onRawDataConfirm"
            >
              Confirm
            </v-btn>
          </template>

          <v-data-iterator
            v-else
            dense
            :items="accounts"
            :footer-props="{ 'items-per-page-options': [50, 100, -1] }"
            :items-per-page="50"

          >
            <template v-slot:header>
              <h3>Search Term</h3>
            </template>


            <template v-slot:default="{items}">
              <v-row  style="max-height: calc(100vh - 160px); overflow-y: auto;">
                <v-col
                  v-for="item in items"
                  :key="item.search_term"
                  cols="12"
                  sm="6"
                  md="3"
                  lg="2"
                >
                  <v-text-field
                    v-model="item.search_term"
                    style="max-width: 15rem;"
                    class="my-2"
                    hide-details
                    dense
                  />
                </v-col>
              </v-row>
            </template>

          </v-data-iterator>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<style lang="scss" scoped>

  .accounts-list-textarea {
    ::v-deep(textarea) {
      max-height: calc(100vh - 190px) !important;
      overflow-y: auto !important;
    }
  }

  .paymethods-autocomplete {
    ::v-deep(.v-input__control) {
      max-height: calc(100vh - 250px);
      overflow-y: auto;
      overflow-x: hidden;
    }

  }
</style>

<script>
import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

export default {
  components: {
    SelectProject,
  },
  props: {
    isLoading: Boolean,
    paymethods: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      project: null,
      selectedPaymethods: [],
      rawAccounts: '',
      accounts: [],
      headers: [
        { text: 'Search Term', value: 'search_term' },
      ],
      searchBy: 'login',
    }
  },

  methods: {
    onRawDataConfirm() {
      this.accounts = this.rawAccounts.split('\n').filter(Boolean).map(search_term => ({ search_term }))
    },
    onUpdateConfirm() {
      this.$root.$confirm('Confirm', 'Are you sure you want to update the whitelisted paymethods of all accounts in the table?')
        .then(yes => {
          if (!yes) {
            return
          }

          this.$emit('bulk-update', {
            accounts: this.accounts.map(({search_term}) => search_term),
            fields: {
              whitelisted: this.selectedPaymethods,
            },
            search_by: this.searchBy,
            entity_id: this.project,
          })
        })
    },
    onWhitelistAll() {
      this.$root.$confirm('Confirm', 'Whitelist ALL paymethods for ALL of the specified accounts in ALL available projects?')
        .then(yes => {
          if (!yes) {
            return
          }

          this.$emit('whitelist-all', {
            accounts: this.accounts.map(({search_term}) => search_term),
            search_by: this.searchBy,
          })
        })
    }
  },

  watch: {
    project(newValue) {
      this.selectedPaymethods = []
      if (newValue) {
        this.$emit('project-selected', newValue)
      }
    }
  }
}
</script>
